module.exports = __webpack_public_path__ + "static/media/ddlizhiliuchengtu.9df21c4f.png";